import videojs from 'video.js';
import utils from './utils.js';

const dom = videojs.dom || videojs;

const DEFAULTS = {

};

/**
 * The class for managing moment
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends EventTarget
 */
class Moment extends videojs.EventTarget {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options);

		super(player, options_);

		for (let opt in options_) {
			this[opt] = options_[opt];
		}

		this.player = player;
		this.el = null;
		this.elPopup = null;
		this.elPopupItem = null;
		this.elPopupItems = null;
		this.elArr = null;
		this.prev = this.list.items[this.listPos - 1];
	}

	setListeners_() {
		videojs.on(this.el, 'mouseenter', this.showTooltip.bind(this));
		videojs.on(this.elPopup, 'mouseleave', this.hideTooltip.bind(this));
		videojs.on(this.el, 'mouseleave', (e) => {
			let newEl = e.toElement || e.relatedTarget;
			if ([this.elPopup, this.elPopupItems, this.elPopupItem].includes(newEl) ||
				[this.elPopupItems].includes(newEl.parentNode) || 
				[this.elPopupItems].includes(newEl.parentNode.parentNode)) return;
			this.hideTooltip();	
		});

		videojs.on(this.elPopupItem, 'click', () => {
			this.play();
		});
	}

	createTimelineLable_() {
		if (this.el) {
			this.clear();
		}

		let evDur = this.player.duration(), //or less accurate: this.list.evFinish - this.list.evStart,
			pos = ((this.start - this.list.evStart) / evDur * 100).toFixed(2),
			width = ((this.finish - this.start) / evDur * 100).toFixed(2);

		this.el = dom.createEl('div', {
			className: 'vjs-moments-item'
		}, {
			style: `left: ${pos}%; width: ${width}%; min-width: 1%;`,
			'data-id': this.id
		});

		dom.appendContent(this.el, this.createTooltipArr_());
		dom.appendContent(this.player.$('.vjs-progress-holder'), [this.el, this.createTooltipPopup_()]);
	}

	createTooltipArr_() {
		let arr = dom.createEl('span', {
				className: 'vjs-moments-item-arr vjs-hidden'
			});
		this.elArr = arr;
		return arr; 
	}

	createTooltipPopup_() {
		let [popup, popupItems] = this.getPopupEl_(),
			row = dom.createEl('div', {
				className: 'vjs-moments-ip-row'
			}),
			icon = dom.createEl('span', {
				className: 'vjs-moments-ipr-icon'
			}, {
				style: `background-image: url(${this.list.types_[this.typeId].icon})`
			}),
			title = dom.createEl('span', {
				className: 'vjs-moments-ipr-title'
			}),
			desc = dom.createEl('span', {
				className: 'vjs-moments-ipr-desc'
			});

		let momentStart = this.start - this.list.evStart;
		if (momentStart < 0) {
			momentStart = 0;
		}

		dom.appendContent(title, [
			this.list.types_[this.typeId].name, 
			', ', 
			utils.formatTime(momentStart)
		]);
		dom.appendContent(desc, this.description);
		dom.appendContent(row, [icon, title, desc]);
		dom.appendContent(popupItems, row);

		this.elPopupItem = row;
		return popup;
	}

	getPopupEl_() {
		let popup,
			items; 
		if (this.hasIntersection_()) { // use previous popup
			popup = this.prev.elPopup;
			items = this.prev.elPopupItems;
		} else {
			items = dom.createEl('div', {
				className: 'vjs-moments-ip-rows'
			});
			popup = dom.createEl('div', {
				className: 'vjs-moments-item-popup vjs-hidden'
			});	
			dom.appendContent(popup, items);
		}

		this.elPopup = popup;
		this.elPopupItems = items;
		return [popup, items];
	}

	hasIntersection_() {
		return this.prev && 
			parseFloat(this.prev.el.style.left) + 
			Math.max(parseFloat(this.prev.el.style.width), parseFloat(this.prev.el.style.minWidth)) > parseFloat(this.el.style.left);
	}

	render() {
		this.createTimelineLable_();
		this.setListeners_();
		this.trigger('rendered');
	}

	play() {
		let seekTo = this.start - this.list.evStart; 
		this.player.currentTime(seekTo);
	}

	toggleTooltip() {
		videojs.dom.hasClass(this.elPopup, 'vjs-hidden') ? this.showTooltip() : this.hideTooltip();
	}

	showTooltip() {
		this.list.items.forEach((m) => { m.hideTooltip(); });
		videojs.dom.removeClass(this.elArr, 'vjs-hidden');
		videojs.dom.removeClass(this.elPopup, 'vjs-hidden');
		videojs.dom.addClass(this.player.$('.vjs-mouse-display'), 'vjs-moments-hide-time');
		videojs.dom.addClass(this.player.$('.vjs-play-progress'), 'vjs-moments-hide-time');
	}

	hideTooltip() {
		videojs.dom.addClass(this.elArr, 'vjs-hidden');
		videojs.dom.addClass(this.elPopup, 'vjs-hidden');
		videojs.dom.removeClass(this.player.$('.vjs-mouse-display'), 'vjs-moments-hide-time');
		videojs.dom.removeClass(this.player.$('.vjs-play-progress'), 'vjs-moments-hide-time');
	}

	clear() {
		this.el && this.el.parentNode && this.el.parentNode.removeChild(this.el);
		this.elArr && this.elArr.parentNode && this.elArr.parentNode.removeChild(this.elArr);
		this.elPopup && this.elPopup.parentNode && this.elPopup.parentNode.removeChild(this.elPopup);
		this.el = null;
		this.elPopup = null;
		this.elPopupItem = null;
		this.elPopupItems = null;
		this.elArr = null;
	}
}

export default Moment;